import { HttpInterceptorFn } from '@angular/common/http';
import {inject} from "@angular/core";
import {LocalStorageService} from "../services/local-storage.service";
import {UserDataService} from "../services/user-data.service";

export const tokenInterceptor: HttpInterceptorFn = (req, next) => {
  const tokenOpt = inject(UserDataService).getAccessToken()
  if (tokenOpt) {
    req = req.clone({setHeaders: {Authorization: `Bearer ${tokenOpt}`}});
  }
  return next(req);
};
